<template>
  <div v-if="$auth.check()">
    <v-app-bar app color="primary" dark clipped-right>
      <v-app-bar-nav-icon @click.stop="clickNavIcon"></v-app-bar-nav-icon>
      <v-toolbar-title>PRODMAN</v-toolbar-title>
      <v-spacer></v-spacer>
      <div v-if="false">
        <v-btn text v-for="(link,i) in links" :key="i" :to="link.to"></v-btn>
      </div>
    </v-app-bar>
  </div>
</template>
<script>
import { header } from "@/router/links";
import resize from "@/mixins/resize";
import { mapMutations } from "vuex";

export default {
  components: {
    SideBar: () => import("./_drawer_01")
  },
  mixins: [resize],
  data() {
    return {
      links: header,
      show_side_bar: false
    };
  },
  methods: {
    ...mapMutations({
      setDrawer: "App/setDrawer"
    }),
    onClick() {},
    clickNavIcon() {
      this.setDrawer(!this.$store.state.App.drawer);
    }
  }
};
</script>